ACC.laserCuttingFileUploadComponent = {

    adjustAddToCartRequest: function () {
        $('#laserCuttingFileUniqueId').val(localStorage.getItem('laserCuttingFileUniqueId'))
    },

    checkForFileThenRender: function () {
        if (localStorage.getItem('realFileName')) {
            $(".remove-file-container").removeClass('hide-element');
            $('.upload-component-form').addClass('hide-element');
            $('.file-upload-component .file-name').html('<p>' + localStorage.getItem('realFileName') + '</p>');
            $('.file-upload-component').attr('data-upload-state', 'uploaded');
            ACC.laserCuttingFileUploadComponent.adjustAddToCartRequest();
        } else {
            $(".remove-file-container").addClass('hide-element');
            $('.upload-component-form').removeClass('hide-element');
            $('.file-upload-component').attr('data-upload-state', 'no-upload');
        }
        if ($('.productDetailsPanel')[0]) {
            callVariantResource(ACC.productDetail.getAllDimensionCodes());
        }
    }
}

$(document).ready(function () {

    function uploadFile(event) {
        var formData = new FormData();
        formData.append('file', event.target.files[0]);
        $.ajax({
            url: ACC.pdp.uploadFileUrl,
            type: "POST",
            headers: {
                CSRFToken: ACC.config.CSRFToken,
            },
            data: formData,
            contentType: false,
            processData: false,

            error: function (data, status) {
                for (var errorMessage in data.responseJSON) {
                    $('.upload-error-messages').append('<p class="error-message">' + data.responseJSON[errorMessage].code + '</p>')
                }
            },

            success: function (data) {
                $('.upload-error-messages').html('');
                localStorage.setItem('laserCuttingFileUniqueId', data.code);
                localStorage.setItem('realFileName', data.realFileName);
                ACC.laserCuttingFileUploadComponent.checkForFileThenRender();
            }
        })
    }

    function removeFile() {
        $.ajax({
            url: ACC.pdp.removeFileUrl,
            headers: {
                CSRFToken: ACC.config.CSRFToken,
            },
            type: "POST",

            error: function (data, status) {
                for (var errorMessage in data.responseJSON) {
                    $('.upload-error-messages').append('<p class="error-message">' + data.responseJSON[errorMessage].code + '</p>')
                }
            },

            success: function () {
                $('.upload-error-messages').html('');
                localStorage.removeItem("laserCuttingFileUniqueId");
                localStorage.removeItem("realFileName");
                $('.file-upload-input').val("");
                ACC.laserCuttingFileUploadComponent.checkForFileThenRender();
            }
        })
    }

    function replaceFile(event) {
        var formData = new FormData();
        var $form= $(this).closest('form');
        formData.append('file', event.target.files[0]);
        formData.append('replaceFileAttributes', new Blob([JSON.stringify({
            'entryNumber': $form.find('input[name="entryNumber"]').val(),
            'cartCode': $form.find('input[name="cartCode"]').val(),
            'productCode': $form.find('input[name="productCode"]').val(),
            'masterCartType': $form.find('input[name="masterCartType"]').val()
        })], {
            type: "application/json"
        }));

        $.ajax({
            url: ACC.pdp.replaceFileUrl,
            headers: {
                CSRFToken: ACC.config.CSRFToken,
            },
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,

            error: function (data, status) {
                for (var errorMessage in data.responseJSON) {
                    $('.upload-error-messages').append('<p class="error-message">' + data.responseJSON[errorMessage].code + '</p>')
                }
            },
            success: function () {
                $('.upload-error-messages').html('');
                window.location.reload();
            }
        })
    }

    $('.file-replace-input').on('propertychange input', replaceFile);

    $('.file-upload-input').on('propertychange input', uploadFile);

    $('.remove-file-button').on('click', removeFile);

    if (document.querySelector(".js-laser-cutting-feature") !== null) {
        ACC.laserCuttingFileUploadComponent.checkForFileThenRender();
    }
});